import React from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { ClipboardList, FileText, BarChart3 } from 'lucide-react';
import SectionBackButton from '../components/SectionBackButton';
import JobTracker from './JobTracker';
import JobCvManager from './JobCvManager';
import JobDashboard from './JobDashboard';

const JobMenu: React.FC = () => {
  const navigate = useNavigate();

  const cards = [
    {
      title: 'Application Tracker',
      description: 'Track your job applications and their status',
      icon: ClipboardList,
      path: '/job/tracker',
    },
    {
      title: 'CV Manager',
      description: 'Upload and manage your CVs',
      icon: FileText,
      path: '/job/cv-manager',
    },
    {
      title: 'Dashboard',
      description: 'Stats and overview of your job hunt',
      icon: BarChart3,
      path: '/job/dashboard',
    },
  ];

  return (
    <div className="min-h-screen bg-theme-secondary pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-8">
          <h1 className="text-3xl font-bold text-theme-primary mb-2">Job</h1>
          <p className="text-theme-secondary mb-8">Job hunting tools and tracking</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {cards.map((card) => (
              <div
                key={card.path}
                className="bg-theme-primary rounded-lg shadow-sm border border-theme-primary p-6 cursor-pointer hover:shadow-md transition-shadow group"
                onClick={() => navigate(card.path)}
              >
                <div className="flex items-center justify-between mb-4">
                  <card.icon className="h-8 w-8 text-theme-primary group-hover:text-blue-500 transition-colors" />
                </div>
                <h3 className="text-lg font-semibold text-theme-primary mb-2">{card.title}</h3>
                <p className="text-theme-secondary text-sm">{card.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const JobSection: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<JobMenu />} />
      <Route
        path="tracker"
        element={
          <>
            <SectionBackButton to="/job" label="Back to Job" />
            <JobTracker />
          </>
        }
      />
      <Route
        path="cv-manager"
        element={
          <>
            <SectionBackButton to="/job" label="Back to Job" />
            <JobCvManager />
          </>
        }
      />
      <Route
        path="dashboard"
        element={
          <>
            <SectionBackButton to="/job" label="Back to Job" />
            <JobDashboard />
          </>
        }
      />
    </Routes>
  );
};

export default JobSection;
